import { MapPin } from 'lucide-react';
import './FloatingButtons.css';

const FloatingMapButton = () => {
    return (
        <a
            href="https://maps.app.goo.gl/V2CHTWXAMQnvvGDi9"
            target="_blank"
            rel="noopener noreferrer"
            className="floating-map-button"
            aria-label="View location on map"
            title="Open Google Maps"
        >
            <MapPin size={28} />
        </a>
    );
};

export default FloatingMapButton;
